import { PATH_DICTS_DEPARTMENT_BASED_PROJECT_RATES } from "@/constants";
import { createDictionaryLabels } from "@/containers/dictionaries/createDictionaryLabels";
import { Module } from "@/constants";
import { getDictionaryLabels } from "@/containers/dictionaries/getDictionaryLabels";
import { DictionaryConfig } from "@/containers/dictionaries/types";
import { BadgeDollarSign } from "lucide-react";
import {
  ReadDepartmentBasedProjectRates,
  writeDepartmentBasedProjectRates,
  WriteDepartmentBasedProjectRates,
} from "@/schemas/departmentBasedProjectRates";
import DepartmentBasedProjectRatesCreator from "@/modules/departmentBasedProjectRates/components/DepartmentBasedProjectRatesCreator";
import DepartmentBasedProjectRatesEditor from "@/modules/departmentBasedProjectRates/components/DepartmentBasedProjectRatesEditor";
import { DepartmentBasedProjectRatesService } from "@/modules/departmentBasedProjectRates/service/departmentBasedProjectRatesService";
import { DepartmentBasedProjectRatesDirectory } from "@/modules/departmentBasedProjectRates/components/DepartmentBasedProjectRatesDirectory";

const id = Module.DepartmentBasedProjectRates;
const path = PATH_DICTS_DEPARTMENT_BASED_PROJECT_RATES;
const ns = "departmentBasedProjectRates";

const config: DictionaryConfig<
  ReadDepartmentBasedProjectRates,
  WriteDepartmentBasedProjectRates
> = {
  id,
  ns,
  service: DepartmentBasedProjectRatesService,
  path,
  labels: createDictionaryLabels(ns),
  getLabels: getDictionaryLabels,
  schema: writeDepartmentBasedProjectRates,
  excludeFromDefaultMenu: true,
  defaultValues: {
    payroll_department_id: "",
    store_id: "",
    valid_from: new Date().toISOString().split("T")[0],
    settlement_type: "",
    rate_student_net: "0,00",
    rate_student_tax: "0,00",
    rate_kch_net: "0,00",
    rate_kch_tax: "0,00",
    rate_zus_net: "0,00",
    rate_zus_tax: "0,00",
    rate_zus_sick_net: "0,00",
    rate_zus_sick_tax: "0,00",
    rate_gross: "0,00",
  },
  Icon: BadgeDollarSign,
  List: () => <DepartmentBasedProjectRatesDirectory ns={ns} path={path} />,
  Creator: DepartmentBasedProjectRatesCreator,
  Editor: DepartmentBasedProjectRatesEditor,
};

export default config;
